import { 
  CATEGORY_ARTICLE_LIST_DATA,
  ARTICLE_DETAILS_DATA,
  ARTICLE_LIST_DATA,
  ADD_CATEGORY_ARTICLE_DATA,
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL,
  UPDATE_CATEGORY_ARTICLE_DATA,
  ADD_CATEGORY_ARTICLE_S3_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  articles: [],
  error: null,
  categoryarticle: {},
  categoryarticleDetail: {},
  updateError: null,
  updateSuccess: false,
  addError: null,
  addSuccess: false,
  articleDetailError: null,
  articleDetailSuccess: false,
  categoryconfig: {},
  s3UploadLoading: false,
  s3UploadSuccess: false,
  s3UploadError: null,
  s3UploadUrl: null,
  categoryArticleList: {},
  categoryArticleListLoading: false,
  categoryArticleListError: null,
};

const initialArticleDetailsState = {
  loading: false,
  article: null,
  error: null,  
};

export const articleListReducer = (state = initialState, action) => {
  switch (action.type) {
    
        // Category article list
    case CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_LOAD:
      return {
        ...state,
        categoryArticleListLoading: true,
        categoryArticleListError: null,
      };
    case CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_SUCCESS:
      return {
        ...state,
        categoryArticleListLoading: false,
        categoryArticleList: action.categoryArticleList,
      };
    case CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_FAIL:
      return {
        ...state,
        categoryArticleListLoading: false,
        categoryArticleListError: action.error,
      };

    case ARTICLE_LIST_DATA.GET_ARTICLES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ARTICLE_LIST_DATA.GET_ARTICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: action.articles,
      };

    case ARTICLE_LIST_DATA.GET_ARTICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // Add article
    case ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        categoryarticle: {},
        error: null,
      };
    case ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryarticle: action.categoryarticle,
        error: null,
        addSuccess: true,
      };
    case ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        categoryarticle: {},
        error: action.error,
        addSuccess: false,
        addError: action.error,
      };
    case ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_RESET:
      return {
        ...state,
        loading: false,
        categoryarticle: {},
        error: null,
        addSuccess: false,
        addError: null,
      };

    // Get article detail
    case LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_LOAD:
      return {
        ...state,
        loading: true,
        categoryarticleDetail: {},
        articleDetailError: null,
        articleDetailSuccess: false,
      };
    case LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryarticleDetail: action.categoryarticleDetail,
        articleDetailError: null,
        articleDetailSuccess: true,
      };
    case LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        categoryarticleDetail: {},
        articleDetailError: action.error,
        articleDetailSuccess: false,
      };
      // Update article
case UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_LOAD:
  return {
    ...state,
    loading: true,
    updateError: null,
    updateSuccess: false
  };

case UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_SUCCESS:
  return {
    ...state,
    loading: false,
    updateSuccess: true,
    updateError: null
  };

case UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_FAIL:
  return {
    ...state,
    loading: false,
    updateSuccess: false,
    updateError: action.error
  };

case UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_RESET:
  return {
    ...state,
    updateSuccess: false,
    updateError: null
  };

    // Add article to S3
    case ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_LOAD:
      return {
        ...state,
        s3UploadLoading: true,
        s3UploadSuccess: false,
        s3UploadError: null,
        s3UploadUrl: null,
      };

    case ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_SUCCESS:
      return {
        ...state,
        s3UploadLoading: false,
        s3UploadSuccess: true,
        s3UploadUrl: action.s3Url ,
      };

    case ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_FAIL:
      return {
        ...state,
        s3UploadLoading: false,
        s3UploadSuccess: false,
        s3UploadError: action.error,
      };

    case ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_RESET:
      return {
        ...state,
        s3UploadLoading: false,
        s3UploadSuccess: false,
        s3UploadError: null,
        s3UploadUrl: null,
      };  

    default:
      return state;
  }
};

export  function articleDetailsReducer(state = initialArticleDetailsState, action) {
  switch (action.type) {
    case ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        article: null,
      };

    case ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        article: action.data,
      };

    case ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
  

    default:
      return state;
  }
}


